import React, { useState, useEffect } from 'react';

const styles = {
  banner: {
    position: 'fixed', bottom: 20, left: '50%', transform: 'translateX(-50%)',
    zIndex: 8000, background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
    borderRadius: 14, padding: '14px 20px', display: 'flex',
    alignItems: 'center', gap: 12, maxWidth: 400, width: 'calc(100% - 32px)',
    boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
    border: '1px solid rgba(255,255,255,0.1)',
    animation: 'vtdSlideUp .4s ease',
  },
  icon: { fontSize: 24, flexShrink: 0 },
  text: { color: '#fff', fontSize: 13, lineHeight: 1.4, flex: 1 },
  bold: { fontWeight: 600, display: 'block', marginBottom: 2, fontSize: 14 },
  btns: { display: 'flex', gap: 8, flexShrink: 0 },
  enableBtn: {
    background: 'linear-gradient(135deg, #667eea, #764ba2)',
    border: 'none', borderRadius: 8, padding: '8px 16px',
    color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer',
  },
  dismissBtn: {
    background: 'transparent', border: '1px solid rgba(255,255,255,0.2)',
    borderRadius: 8, padding: '8px 12px',
    color: 'rgba(255,255,255,0.6)', fontSize: 13, cursor: 'pointer',
  },
};

const slideUp = `@keyframes vtdSlideUp { from { opacity: 0; transform: translateX(-50%) translateY(20px); } to { opacity: 1; transform: translateX(-50%) translateY(0); } }`;

export default function NotificationPrompt({ onSubscribe }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!('Notification' in window) || !('serviceWorker' in navigator)) return;
    if (Notification.permission !== 'default') return;
    const dismissed = localStorage.getItem('vtd_notif_dismissed');
    if (dismissed) return;

    const timer = setTimeout(() => setVisible(true), 5000);
    return () => clearTimeout(timer);
  }, []);

  const handleEnable = async () => {
    setVisible(false);
    onSubscribe?.();
  };

  const handleDismiss = () => {
    setVisible(false);
    localStorage.setItem('vtd_notif_dismissed', Date.now().toString());
  };

  if (!visible) return null;

  return (
    <>
      <style>{slideUp}</style>
      <div style={styles.banner}>
        <span style={styles.icon}>&#x1F514;</span>
        <div style={styles.text}>
          <span style={styles.bold}>Stay in the loop</span>
          Get alerts for incoming calls and messages
        </div>
        <div style={styles.btns}>
          <button style={styles.enableBtn} onClick={handleEnable}>Enable</button>
          <button style={styles.dismissBtn} onClick={handleDismiss}>Later</button>
        </div>
      </div>
    </>
  );
}
